import CreateVoucher from './CreateVoucher.js';
export default CreateVoucher;
//# sourceMappingURL=index.js.map